import React from "react";
import bgHead from "../../../assets/requirement-background.png";

export default function Headline() {
  return (
    <div
      style={{
        backgroundColor: "white",
      }}
    >
      <div className="container">
        <div
          style={{
            height: 350,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            position: "relative",
          }}
        >
          <img
            src={bgHead}
            alt="image"
            style={{
              height: "288px",
              width: "484px",
              marginBottom: 44,
              objectFit: "cover",
              marginTop: "40px ",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              width: "100%",
              textAlign: "center",
            }}
          >
            <p
              style={{
                textAlign: "center",
                color: '#1672BD'
              }}
              className="h1-nunito"
            >
              Persyaratan Menjadi PSrE Indonesia (Berinduk)
            </p>
            <h1
              style={{
                textAlign: "center",
              }}
              className="h6-nunito"
            >
              PSrE yang beroperasi di Indonesia wajib mendapatkan pengakuan Menteri Kominfo dengan berinduk ke PSrE Induk.
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
